import * as React from 'react';
import {
    Edit,
    DateInput,
    NumberInput,
    BooleanInput,
    TextInput,
    SimpleForm,
    SaveButton,
    Toolbar,
} from 'react-admin';
import { IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';

const OrderDetailEditToolbar = ({ onCancel }) => (
    <Toolbar
        sx={{
            display: 'flex',
            justifyContent: 'space-between',
        }}
    >
        <SaveButton alwaysEnable />
        <IconButton onClick={onCancel} size="small">
            <CancelIcon />
        </IconButton>
    </Toolbar>
);

const OrderDetailEdit = ({ onCancel, ...props }) => {
    return (
        <Box sx={{ width: 400, paddingTop: '80px' }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    paddingRight: '16px',
                    paddingBottom: '8px',
                }}
            >
                <IconButton onClick={onCancel} size="small">
                    <CloseIcon />
                </IconButton>
            </Box>
            <Edit
                {...props}
                redirect={false}
                mutationMode="pessimistic"
                mutationOptions={{
                    onSuccess: () => {
                        onCancel();
                    }
                }}
            >
                <SimpleForm
                    toolbar={<OrderDetailEditToolbar onCancel={onCancel} />}
                >
                    <DateInput label="Delivery Date" source="Delivery_Date" />
                    <NumberInput label="Qty Loaded" source="Qty_Loaded" step={1} parse={v => v === '' ? null : v} />
                    <TextInput label="Invoice #" source="Invoice_Num" inputProps={{ maxLength: 6 }} />
                    <BooleanInput label="Canceled" source="Canceled" />
                </SimpleForm>
            </Edit>
        </Box>
    );
};

export default OrderDetailEdit;
